import moment from 'moment';

export const durationLength = (duration) => {
  return duration.validLength;
};

// validToDate(startDate: moment(), duration: Durations[key])
export const validToDate = (startDate, duration) => {
  const endDate = moment(startDate).add(duration.days - 1, 'day');

  if (!duration.endEndOfMonth) {
    return endDate;
  }

  return endDate.endOf('month');
};
